export const PRINT_MEDIA_ROUTES = {
    dashboard: "/media",
    manageSearchTerms: "/manage_search_terms",
    reports: "/print_media_reports",
    reportEdit: (reportId: number | string) => `/print_media_reports/edit/${reportId}`,
    reportView: (reportId: number | string) => `/print_media_reports/view/${reportId}`,
};

export const PRINT_MEDIA_PAGE_SIZE = 50;

export const PRINT_MEDIA_LANGUAGES: Record<string, string> = {
    en: "English",
    hi: "Hindi",
    kn: "Kannada",
    ta: "Tamil",
    te: "Telugu",
    ml: "Malayalam",
    bn: "Bengali",
    mr: "Marathi",
    pa: "Punjabi",
    gu: "Gujarathi",
    ur: "Urdu",
    or: "Odiya",
    as: "Assamese",
};
